import { request } from 'shared/lib/request';

export const getCarbonEmissionRequest = () => request.get('/emissions');
export const getCarbonContactRequest = () => request.post('/contact-cf');
